import React, { useEffect, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  makeStyles,
  Paper,
  Typography,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import jMoment from "moment-jalaali";
import { Edit } from "@material-ui/icons";
import SupplementaryInfoForm from "../../../components/supplementaryInfoForm/SupplementaryInfoForm";
import { useFetch } from "../../../features/customHooks/useFetch";
jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: false });

const useStyles = makeStyles((theme) => ({
  title: { fontWeight: "bold", fontSize: 15 },
  value: { fontSize: 15, marginLeft: 5 },
}));

const SupplementaryInfo = (props) => {
  const classes = useStyles();
  const { data } = props;
  const { loading = true, valuation = [], regetValuation } = data;

  const supplementaryInfoRef = useRef(null);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const handleOpenDialog = () => setEditDialogOpen(true);
  const handleCloseDialog = () => setEditDialogOpen(false);

  const [updateFetchState, setUpdateFetchParams] = useFetch();

  const onSubmitForm = (data, event) => {
    console.log(data);
    const params = {
      method: "put",
      url: "/valuation/" + valuation?.id,
      data: data,
    };
    setUpdateFetchParams(params);
  };

  useEffect(() => {
    if (!updateFetchState.loading && !updateFetchState.error && updateFetchState.data) {
      handleCloseDialog();
      regetValuation();
    }

    if (!updateFetchState.loading && updateFetchState.error) {
      console.log("error");
    }
  }, [updateFetchState]);

  return (
    <Paper style={{ padding: 10 }}>
      <Grid container alignItems='center'>
        <Typography variant='h6' style={{ fontWeight: "bold" }}>
          اطلاعات تکمیلی
        </Typography>

        <div style={{ flexGrow: 1 }} />
        {valuation?.can_edit && (
          <Tooltip title='ویرایش' onClick={handleOpenDialog}>
            <IconButton>
              <Edit />
            </IconButton>
          </Tooltip>
        )}
      </Grid>

      {loading ? (
        <Grid container alignItems='center' justifyContent='center'>
          <CircularProgress style={{ color: "#757575" }} />
        </Grid>
      ) : (
        <Grid container direction='row'>
          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>ارزش محوطه سازی:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.enclosure_value &&
                  parseInt(valuation?.enclosure_value)?.toLocaleString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={9}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>توضیحات محوطه سازی:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.enclosure_description?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>ارزش امتیازات:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.credits_sum && parseInt(valuation?.credits_sum)?.toLocaleString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={9}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>توضیحات امتیازات:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.credits_description?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

      {valuation?.can_edit && (
        <Dialog open={editDialogOpen} maxWidth={"md"} fullWidth>
          <DialogTitle>ویرایش اطلاعات تکمیلی</DialogTitle>
          <DialogContent>
            <SupplementaryInfoForm
              ref={supplementaryInfoRef}
              onSubmitForm={onSubmitForm}
              defaultValues={{
                enclosure_value: valuation?.enclosure_value,
                enclosure_description: valuation?.enclosure_description,
                credits_sum: valuation?.credits_sum,
                credits_description: valuation?.credits_description,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>لغو</Button>
            <Button variant='contained' color='primary' onClick={() => supplementaryInfoRef.current.submit()}>
              {updateFetchState?.loading ? <CircularProgress size={23} color='inherit' /> : "ویرایش"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Paper>
  );
};

export default SupplementaryInfo;
